import * as React from "react"
import {Box, Divider} from "@mui/material";
import {ButtonIconSeeker} from "@ui-seeker/core";

import {reverseMatcherImageSize} from "../../@signals";


export default function ReverseMatcherTargetActionsZoom() {
	return <Box sx={{ display: 'flex', gap: 2 }}>
		<ButtonIconSeeker
			disabled={reverseMatcherImageSize.value === 0}
			icon="magnifying-glass-minus"
			onClick={() => reverseMatcherImageSize.value -= 1}
			tooltip="zoom -"
		/>

		<ButtonIconSeeker
			disabled={reverseMatcherImageSize.value === 2}
			icon="magnifying-glass-plus"
			onClick={() => reverseMatcherImageSize.value += 1}
			tooltip="zoom +"
		/>

		<Divider orientation="vertical" flexItem />
	</Box>
}